export default __webpack_public_path__ + "static/media/img6.e4d79232.png";